

const setTitle = (title: string) => {
    document.title = title;
}


const setFavIcon = (path: string) => {
    const favIcon = document.getElementById('favicon') as HTMLLinkElement | null;

    if (favIcon != null) {
        favIcon.href = path;
    }
}


const DocumentHelper = {
    setTitle,
    setFavIcon
}


export default DocumentHelper;